import { useState } from 'react'
import Button from '@mui/joy/Button'
import Box from '@mui/joy/Box'
import { Loading } from './ui/Loading'
import { SchedulerFormFields } from './SchedulerFormFields'
import { ErrorAlert } from './ui/ErrorAlert'
import { validateSchedulerFields } from '../common/utils'
import dayjs from 'dayjs'
import _ from 'lodash'

export const SchedulerForm = ({ onSubmit, id, fileType }) => {
    const [alerts, setAlerts] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [postData, setPostData] = useState({
        date: null,
        time: null,
        caption: null,
        publishTo: null,
    })

    const alertEls = alerts.map((alert) => (
        <>
            <ErrorAlert>Fix {alert}</ErrorAlert>
        </>
    ))

    const handleChange = (data) => {
        setPostData({ ...data })
    }

    const isDateFuture = (dt) => {
        return dayjs().isBefore(dt)
    }

    const handleSubmit = () => {
        let errorFields = validateSchedulerFields(postData)
        if (errorFields.length > 0) {
            setAlerts(errorFields)
            return
        }
        let date = postData.date
        let time = postData.time
        let schedule_date = date
            .hour(time.hour())
            .minute(time.minute())
            .second(time.second())
        if (!isDateFuture(schedule_date)) {
            setAlerts(['date', 'time'])
            return
        }

        console.log('validation successful, submitting...')
        setAlerts([])
        setIsSubmitting(true)
        const assetObj = {
            caption: postData.caption,
            publishTo: postData.publishTo,
            schedule_date: schedule_date.toISOString(),
        }
        onSubmit(id, assetObj)
    }

    if (isSubmitting) {
        return <Loading message="submitting..." />
    }

    return (
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <SchedulerFormFields
                date={postData.date}
                time={postData.time}
                caption={postData.caption}
                publishTo={postData.publishTo}
                onChange={handleChange}
                fileType={fileType}
            />
            <Button onClick={handleSubmit}>Submit</Button>
            {alertEls}
        </Box>
    )
}
